const isFulfilled = async (p: Promise<any>): Promise<boolean> => {
  try {
    await p;
    return true;
  } catch (e) {
    return false;
  }
};

export default isFulfilled;
